import axios from "axios";

let csrfCookiePromise = null;

export default class Api {
    static getUrl(url) {
        return process.env.VUE_APP_API_URL + url;
    }
    static getEsewaUrl(url) {
        return process.env.VUE_APP_ESEWA_URL + url;
    }
    // Origin of the API (VUE_APP_API_URL is prefixed with /api/v1, but
    // /sanctum/csrf-cookie is served at the API's root, outside that prefix).
    static getOrigin() {
        return new URL(process.env.VUE_APP_API_URL).origin;
    }
    // Fetches the XSRF-TOKEN cookie once per page load; memoized so callers
    // (see the axios request interceptor in store/index.js) can call this
    // before every mutating request without refetching each time.
    static ensureCsrfCookie() {
        if (!csrfCookiePromise) {
            csrfCookiePromise = axios
                .get(`${Api.getOrigin()}/sanctum/csrf-cookie`, { withCredentials: true })
                .catch((error) => {
                    csrfCookiePromise = null;
                    throw error;
                });
        }
        return csrfCookiePromise;
    }
    // Forces the next ensureCsrfCookie() call to re-fetch instead of reusing
    // the memoized cookie from earlier in the page's life (see the 419 retry
    // in the axios response interceptor in store/index.js).
    static resetCsrfCookie() {
        csrfCookiePromise = null;
    }
}